<template>
  <div
    class="background d-flex align-center justify-center"
    style="overflow: hidden; width: 100%"
  >
    <div style="height: 100%; width: 100%">
      <v-row style="height: 100%; width: 100%">
        <v-col cols="4" style="height: 100%">
          <Tree
            @openFile="openFile"
            style="border-right: solid gray 1px; height: 100%; overflow-y: auto"
          />
        </v-col>
        <v-col cols="8" style="height: 100%">
          <Viewer ref="viewer" style="height: 100%" />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Tree from "../components/leodata/Tree.vue";
import Viewer from "../components/leodata/Viewer.vue";
import leodataLogo from "../assets/leodata_logo.png";

export default {
  components: { Tree, Viewer },
  methods: {
    openFile(fileId) {
      this.$refs.viewer.openFile(fileId);
    },
  },
  mounted() {
    const ONE_WEEK_IN_MILLISECONDS = 7 * 24 * 60 * 60 * 1000;
    const lastLeodataPopupDisplay = localStorage.getItem("popup-leodata-1");
    if (
      lastLeodataPopupDisplay === null ||
      Date.now() - new Date(lastLeodataPopupDisplay).getTime() >
        ONE_WEEK_IN_MILLISECONDS
    ) {
      this.$swal
        .fire({
          title: `
          <div style='display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px; margin-top: -30px'>
            <img src='${leodataLogo}' height='80'>
            <div style="font-size: 28px">Aidez-nous à compléter <label style='color:#0899BD'>LÉO</label><label style='color:#D11758'>DA</label><label style='color:#EF8108'>TA</label></div>
          </div>`,
          html: `
           Nous avons besoin de toi pour faire grandir LeoData 💪<br><br>Si tu as un sujet qui n'apparaît pas dans les fichiers, envoie-le-nous par mail à <a href="mailto:leolearning@devinci.fr">leolearning@devinci.fr</a><br><br>Merci 😊
            `,
          confirmButtonText: "OK",
          confirmButtonColor: "#ca8c05",
          iconColor: "#ca8c05",
          showCloseButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            const confirmButton = this.$swal.getConfirmButton();
            confirmButton.disabled = true;
            let secondsLeft = 3;
            confirmButton.textContent = `OK (${secondsLeft})`;
            const interval = setInterval(() => {
              secondsLeft -= 1;
              if (secondsLeft <= 0) {
                clearInterval(interval);
                confirmButton.disabled = false;
                confirmButton.textContent = "OK";
              } else {
                confirmButton.textContent = `OK (${secondsLeft})`;
              }
            }, 1000);
          },
        })
        .then(() => {
          localStorage.setItem("popup-leodata-1", new Date().toISOString());
        });
    }
  },
};
</script>
